import { AUTH_REDUCER_KEY } from 'store/auth/constants'
import { createAction } from 'redux-actions'

export const types = {
  PASSWORD_RESET_EMAIL_LOAD: `${AUTH_REDUCER_KEY}/password_reset/PASSWORD_RESET_EMAIL_LOAD`,
  PASSWORD_RESET_EMAIL_SUCCESS: `${AUTH_REDUCER_KEY}/password_reset/PASSWORD_RESET_EMAIL_SUCCESS`,
}

export const sendResetPasswordEmail = createAction(types.PASSWORD_RESET_EMAIL_LOAD, email => email)
